import { useState } from 'react'
import { db } from '../../../../../config/firebase'
import DeletePopUp from '../../../../../ui/PopUp/DeletePopUp/DeletePopUp'
import { withRouter } from 'react-router-dom'

const DeleteBannerPopUp = ({ bannerId, title, closePopUp, ...router }) => {
  const [isLoading, setIsLoading] = useState(false)

  const onDelete = async () => {
    setIsLoading(true)
    db.collection('settings/banners/list')
      .doc(bannerId)
      .delete()
      .then(() => router.history.push('/settings/banners'))
  }

  return (
    <DeletePopUp
      title="Видалити банер"
      warningMessage={
        <>
          Ви впевнені, що хочете видалити банер <span className="Bolder">"{title}"</span>? Усі фото та та дані, зв'язані
          з цим банером будуть видалені
        </>
      }
      // fieldLabel="Чтобы удалить эту новость, введите ее идентификатор:"
      // identifier={subcategoryId}
      closePopUp={closePopUp}
      submitDelete={onDelete}
      isLoading={isLoading}
    />
  )
}

export default withRouter(DeleteBannerPopUp)
